import * as React from 'react';
import { Card } from 'components/Card';
import { CardRow } from 'components/CardRow';
import { ICONS } from 'components/Icon';
import { ModalScreens } from 'components/Navigation/types';
import { ViewWithSeparators } from 'components/ViewWithSeparators';
import { useSelector } from 'hooks/useSelector';
import { theme } from 'lib/theme';
import { useDispatch } from 'react-redux';
import {
  doAseApprovePrecheck,
  NAVIGATE_MODAL,
  SUBMIT_ASSESSMENT,
} from 'store/actions';
import {
  selectAseFeatures,
  selectAseIsEditable,
  selectAseStatus,
} from 'store/assessments/selectors';
import { AssessmentStatusesEnum } from 'types/types';

export const StatusChange: React.FC = () => {
  const dispatch = useDispatch();
  const features = useSelector(selectAseFeatures);
  const isEditable = useSelector(selectAseIsEditable);
  const status = useSelector(selectAseStatus);
  const featureSubmit =
    isEditable && status.id === AssessmentStatusesEnum.inprogress;

  if (
    !featureSubmit &&
    !features.unsubmit &&
    !features.approve &&
    !features.unapprove
  ) {
    return null;
  }

  return (
    <Card margin={false}>
      <ViewWithSeparators horizontal>
        {featureSubmit && (
          <CardRow
            label="Submit Assessment"
            labelColor={theme.colors.blue}
            // icon={ICONS.ForwardLight}
            // iconColor={theme.colors.blue}
            navigationIcon={ICONS.ForwardLight}
            navigationIconColor={theme.colors.blue}
            onPress={() => dispatch(SUBMIT_ASSESSMENT())}
            style={{ flex: 1 }}
          />
        )}
        {features.unsubmit && (
          <CardRow
            label="Unsubmit"
            // label2="Return to Assessor"
            icon={ICONS.ForwardLight}
            labelColor={theme.colors.blue}
            label2Color={theme.colors.blue}
            iconColor={theme.colors.blue}
            iconStyle={{ transform: [{ rotate: '180deg' }] }}
            style={{ flex: 1 }}
            onPress={() =>
              dispatch(
                NAVIGATE_MODAL({
                  screen: ModalScreens.AseStatusUnsubmit,
                  params: {},
                }),
              )
            }
          />
        )}
        {features.approve && (
          <CardRow
            label="Approve"
            labelColor={theme.colors.green}
            icon={ICONS.ForwardLight}
            iconColor={theme.colors.green}
            style={{ flex: 1 }}
            onPress={() => dispatch(doAseApprovePrecheck())}
          />
        )}
        {features.unapprove && (
          <CardRow
            label="Unapprove Assessment"
            icon={ICONS.ForwardLight}
            labelColor={theme.colors.blue}
            label2Color={theme.colors.blue}
            iconColor={theme.colors.blue}
            iconStyle={{ transform: [{ rotate: '180deg' }] }}
            style={{ flex: 1 }}
            onPress={() =>
              dispatch(
                NAVIGATE_MODAL({
                  screen: ModalScreens.AseStatusUnapprove,
                  params: {},
                }),
              )
            }
          />
        )}
      </ViewWithSeparators>
    </Card>
  );
};
